import w1 from "../assets/images/work/w1.png";
import w2 from "../assets/images/work/w2.png";
import w3 from "../assets/images/work/w3.png";
import w4 from "../assets/images/work/w4.png";
import w5 from "../assets/images/work/w5.png";
import w6 from "../assets/images/work/w6.png";

export const workProjects = [
  {
    slug: "project-1",
    tag: "Case Study",
    title: "Project name or short project outcome",
    desc: "We partnered with a healthcare organization to design and build a solution that addressed core problems and delivered measurable outcomes.",
    services: ["Technical assessment", "Custom development", "Data analytics consulting"],
    image: w1,
  },
  {
    slug: "project-2",
    tag: "Case Study",
    title: "Modern workflow modernization for teams",
    desc: "We partnered with an operations team to streamline workflows, integrate systems, and improve reliability across core processes.",
    services: ["Discovery & planning", "Systems integration", "Automation"],
    image: w2,
  },
  {
    slug: "project-3",
    tag: "Case Study",
    title: "Building a scalable API ecosystem",
    desc: "We helped teams design a robust API layer, enabling faster development cycles and better interoperability between services.",
    services: ["API design", "Development", "Testing & governance"],
    image: w3,
  },
  {
    slug: "project-4",
    tag: "Case Study",
    title: "Secure data platform for real-time insights",
    desc: "We delivered a secure analytics foundation, enabling teams to access trusted data and derive actionable insights.",
    services: ["Data platform", "Security", "Analytics consulting"],
    image: w4,
  },
  {
    slug: "project-5",
    tag: "Case Study",
    title: "Customer experience improvements at scale",
    desc: "We enhanced the customer journey by building scalable UI components and improving performance for high-traffic experiences.",
    services: ["UI/UX delivery", "Performance", "Front-end engineering"],
    image: w5,
  },
  {
    slug: "project-6",
    tag: "Case Study",
    title: "Reliable infrastructure for enterprise growth",
    desc: "We designed and implemented infrastructure improvements that improved reliability, scalability, and operational efficiency.",
    services: ["Cloud infrastructure", "Monitoring", "Optimization"],
    image: w6,
  },
];

